import { apiClient } from '@/api/index';
import { components } from '~/api-types';

export enum InvitationCodeStatus {
  VALID = 'valid',
  INVALID = 'invalid',
}

export type UserDto = components['schemas']['UserResponseDto'];
export type RegisterUserBodyDto = components['schemas']['RegisterUserBodyDto'];
export type RegisterUserWithExternalProviderBodyDTO =
  components['schemas']['LoginBodyDto'];
export type ForgotPasswordBodyDto =
  components['schemas']['ForgotPasswordBodyDto'];
export type UpdateUserBodyDto = components['schemas']['UpdateAuthUserBodyDto'];
export type GetExternalIdentityProviderListDto =
  components['schemas']['GetExternalIdentityProviderListResponseDto'];
export enum ExternalIdentityProviderName {
  GLUU = 'gluu',
}

export const apiGetAuthUser = async (): Promise<UserDto> => {
  const { data } = await apiClient.get('/auth/me');

  return data;
};

export const apiRegisterUser = async (
  payload: RegisterUserBodyDto,
): Promise<UserDto> => {
  const { data } = await apiClient.post('/auth/register', payload);

  return data;
};

export const apiRegisterUserWithExternalProvider = async (
  payload: RegisterUserWithExternalProviderBodyDTO,
): Promise<UserDto> => {
  const { data } = await apiClient.post(
    '/auth/external-provider/register',
    payload,
  );

  return data;
};

export const apiSendPasswordResetEmail = (
  payload: ForgotPasswordBodyDto,
): Promise<void> => {
  return apiClient.post(`/auth/forgot-password`, payload);
};

export const apiUpdateAuthUser = async (
  payload: UpdateUserBodyDto,
): Promise<UserDto> => {
  const { data } = await apiClient.patch('/auth/me', payload);

  return data;
};

export type CheckInvitationCodeBodyDto =
  components['schemas']['CheckInvitationCodeBodyDto'];
export type CheckInvitationCodeResponseDto =
  components['schemas']['CheckInvitationCodeResponseDto'];

export const apiCheckInvitationCode = (
  payload: CheckInvitationCodeBodyDto,
): Promise<CheckInvitationCodeResponseDto> => {
  return apiClient.post(`/auth/check-invitation-code-status`, payload);
};

export const apiLogin = async (
  idToken: string,
): Promise<components['schemas']['LoginResponseDto']> => {
  const { data } = await apiClient.post(`/auth/login`, { idToken });

  return data;
};

export const apiGetExternalIdentityProviderList =
  async (): Promise<GetExternalIdentityProviderListDto> => {
    const { data } = await apiClient.get(`/auth/external-identity-providers`);
    return data;
  };

export const authGenerateApiKey = async (): Promise<{ key: string }> => {
  const { data } = await apiClient.post('/auth/api-key');
  return data;
};

export const apiRevokeApiKey = (): Promise<{ key: string }> => {
  return apiClient.delete('/auth/api-key');
};

export const apiSetNewPassword = (code: string, password: string) => {
  return apiClient.post('/auth/set-password', { code, password });
};

export type ExchangeSsoCodeResponseDto = {
  customToken: string;
};

export const apiExchangeSsoCode = async (
  code: string,
): Promise<ExchangeSsoCodeResponseDto> => {
  const { data } = await apiClient.post('/auth/sso/exchange-code', { code });
  return data;
};
